import { withInstall } from "../utils";
import _TreeSelect from "./TreeSelect";
const TreeSelect = withInstall(_TreeSelect);
var stdin_default = TreeSelect;
export {
  TreeSelect,
  stdin_default as default
};
